import { render } from "./LeaderboardStandalone.vue?vue&type=template&id=660336c0&scoped=true"
import script from "./LeaderboardStandalone.vue?vue&type=script&lang=js"
export * from "./LeaderboardStandalone.vue?vue&type=script&lang=js"

import "./LeaderboardStandalone.vue?vue&type=style&index=0&id=660336c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660336c0"]])

export default __exports__